import BookForm from "components/shared/book/form";
import { connect, generatedActions, viewDispatchToProps, viewStateToProps } from "helpers/redux";
import React from "react";
import { config, initialState } from "../formConfig";

class NewOrganizationCatalog extends BookForm {
    renderBody = () => {
        const { config } = this.props;
        return (
            <>
                {this.renderField(config.displayName)}
                {this.renderField(config.description)}
                {this.renderField(config.externalId)}
                {this.renderSelect(config.entityType)}
            </>
        );
    };
}

const ConfiguredForm = (props) => <NewOrganizationCatalog {...props} config={config} initialState={initialState} />;

const customDispatch = (dispatch) => {
    return {
        ...viewDispatchToProps(dispatch, generatedActions.organizationcatalogs),
        getDictionaries: () => dispatch(generatedActions.dictionaries.index()),
    };
};

export default connect(viewStateToProps, customDispatch)(ConfiguredForm);
